import styled from 'styled-components';

export const XYScrollPane = styled('div')`
  display: flex;
  flex-wrap: nowrap;
  height: auto;
  > div {
    flex: 0 0 33.3333%;
  }
`;

export const CompanyWrapper = styled('div')`
  margin-right: 20px;
  padding: 0;
  min-width: 400px;
  height: auto;
`;

export const CompanyHeaderWrapper = styled('fieldset')`
  background-color: ${({ theme }) => theme.color.darkGray};
  color: white;
  border-bottom: 1px solid white;
  margin: 0;
  padding: ${({ theme }) => theme.x1spacePx}px;
  position: relative;
`;

export const CompanyLabel = styled('h1')`
  padding: 0;
  margin: 0;
  ${({ theme }) => theme.typography.largeStrong}
`;

export const RemoveButton = styled('button')`
  position: absolute;
  right: ${({ theme }) => theme.x1spacePx}px;
  top: ${({ theme }) => theme.x1spacePx}px;
  height: 16px;
  width: 32px;
  > svg {
    width: 24px;
    height: 24px;
    margin-left: -2px;
    > * {
      fill: white;
    }
  }
`;
